<template>
  <div>
    <div>
      <p style="text-align: center; color: white; background-color: #01579B"><b>{{ budgetType.label }}</b></p>
      <Doughnut
          :chart-options="chartOptions"
          :chart-data="chartData"
          :chart-id="chartId"
          :dataset-id-key="datasetIdKey"
          :plugins="plugins"
          :css-classes="cssClasses"
          :styles="styles"
          :width="width"
          :height="height"
      ></Doughnut>
      <br />
      <p style="text-align: center; color: black;">Total Budget: <b>${{ faData.budget }}</b></p> <br /><br />
    </div>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs/legacy'
import ChartDataLabels from 'chartjs-plugin-datalabels'
//npm install chartjs-plugin-datalabels --save
import {
  Chart as ChartJS,
  Title,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'

ChartJS.register(Title, Legend, ArcElement, CategoryScale, ChartDataLabels)

export default {
  name: 'DoughnutChart',
  components: {
    Doughnut
  },
  props: {
    faData: {
      required: true
    },
    budgetType: {
      required: true
    },
    chartId: {
      type: String,
      default: 'doughnut-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartData: {
        labels: ["Available", "Actual"],
        datasets: [
          {
            backgroundColor: ['#A3EBB1',"#F8EA8C"], //[Green,Yellow]
            data: [this.faData.available, this.faData.actual]
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            //Formats the text inside the graph in 'Label: $amount' format
            formatter: function(value, context){
              return context.chart.data.labels[context.dataIndex]+": $"+value
            },
            color: "black"
          }
        },
      }
    }
  }
}
</script>
<style scoped>
p{
  color: black;
}
</style>